import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { useOrganizationAlias } from "@domain/currentProfile/hooks";
import { PostComment } from "@domain/post/comment/postComment";
import { usePostComments } from "@domain/post/hooks";
import { gap } from "@ui/styles/utils";
import { PostCommentSkeleton } from "@ui/components/post/comment/commentView";
import { ParentCommentView } from "@ui/components/post/comment/parentCommentView";

interface PostCommentsListProps extends React.HTMLAttributes<HTMLDivElement> {
	postId: string;
	initialComment?: PostComment;
}
export const PostCommentsList: React.FC<PostCommentsListProps> = ({ postId, initialComment, ...htmlProps }) => {
	const alias = useOrganizationAlias();
	const { result: comments, fetchMore, loading, totalElements } = usePostComments(postId, alias?.id);

	return (
		<Container {...htmlProps}>
			{comments.length < 1 && initialComment && <ParentCommentView postComment={initialComment} postId={postId} />}
			{loading ? (
				<PostCommentSkeleton />
			) : (
				comments.map((postComment) =>
					postComment ? <ParentCommentView key={postComment.id} postComment={postComment} postId={postId} /> : undefined
				)
			)}
			{totalElements !== undefined && totalElements > comments.length && (
				<FetchMore onClick={fetchMore}>{I18n.t("post.comment.more")}</FetchMore>
			)}
		</Container>
	);
};

const Container = styled.div`
	${gap(10)}
`;

const FetchMore = styled.div`
	cursor: pointer;
	${({ theme }) => theme.textStyles.label};
`;
